module.exports = __webpack_public_path__ + "static/media/icon_insight_item.f781ca6d.svg";